import React, { PureComponent } from 'react'

type Props = {
  videoId: string
}

class VideoPlayer extends PureComponent {
  props: Props
  videoElement: Object
  videoEmbed: Object

  componentDidMount (): void {
    const { videoId } = this.props
    const isClient = typeof window !== 'undefined'
    if (isClient) {
      this.videoElement.innerHTML = `<div class="nrk-video" data-nrk-autoplay="${this.isAndroid() ? 'false' : 'true'}" data-nrk-id="${videoId}"></div>`
      if (this.videoEmbed) {
        this.videoEmbed.initialize()
      } else {
        require(['../../utils/video_embed'], (videoEmbed) => {
          this.videoEmbed = videoEmbed
          this.videoEmbed.initialize()
        })
      }
    }
  }

  isAndroid (): boolean {
    const ua = navigator.userAgent.toLowerCase()
    return ua.indexOf('android') > -1
  }

  getWindowSize (): Object {
    const w = window
    const d = document
    const e = d.documentElement
    const g = d.getElementsByTagName('body')[0]
    return {
      width: w.innerWidth || e.clientWidth || g.clientWidth,
      height: w.innerHeight || e.clientHeight || g.clientHeight
    }
  }

  render () {
    let styleWidth = 'auto'
    const { width, height } = this.getWindowSize()
    const ratio = width / height
    if (ratio > 1.7) {
      styleWidth = '70%'
    }
    return <div
      style={{
        width: styleWidth,
        margin: '0 auto'
      }}
      ref={(c) => { this.videoElement = c }}
    />
  }
}

export default VideoPlayer



// WEBPACK FOOTER //
// ./src/shared/components/VideoPlayer/videoPlayer.js